export class TransferStatus {
  transferId: string;
  operationTypeDescription: string;
  status: string;
  message: string;
  lastStatusDate: Date;
  limitDate: Date;
  logList: TransferStatusLog[] = [];
  senderName: string;
  senderDocument: string;
  senderBank: string;
  senderBranch: string;
  senderAccount: string;
  senderAccountDigit: string;
  recipientName: string;
  recipientDocument: string;
  recipientBank: string;
  recipientBranch: string;
  recipientAccount: string;
  recipientAccountDigit: string;
  amount: number;
  description: string;
}

export class TransferStatusLog {
  date: Date;
  status: string;
  errorMessage: string;
}
